import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'


console.log('🔍 Iniciando React App...')

function initReact() {
  const rootElement = document.getElementById('react-root')
  
  if (rootElement) {
    console.log('✅ Montando React en #react-root')
    
    ReactDOM.createRoot(rootElement).render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )
    
    console.log('🎉 React montado!')
  } else {
    console.error('❌ No se encontró #react-root')
  }
}

// Esperar a que el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReact)
} else {
  initReact()
}